import React from 'react';
import { BrowserRouter, HashRouter,Route, Redirect, Switch } from "react-router-dom";
import AppRoute from './routes/AppRoutes';

class Router extends React.Component {
    state = {  }
    render() {        
        return ( 
            <div>               
                <HashRouter>
                <Switch>                                        
                <AppRoute path='/'/> 
                </Switch>
                </HashRouter>               
            </div>
         );
    }
}
 
export default Router;